<script setup lang="ts">
import VModal from '~/components/common/VModal.vue';
import VRecoverPassword from '~/components/auth/VRecoverPassword.vue';
import VAuth from '~/components/auth/VAuth.vue';
import VButton from '~/components/VButton.vue';

const store = useAuthStore();
</script>

<template>
  <v-modal
    :open="store.open !== false"
    @close="store.handleIsOpened(false)"
  >
    <div
      v-if="store.open !== 'recover-password'"
      style="width: 100%"
    >
      <v-auth />

      <v-button
        schema="text"
        type="button"
        style="width: 100%; margin-top: 8px"
        @click="store.handleIsOpened('recover-password')"
      >
        Забыли пароль?
      </v-button>
    </div>

    <v-recover-password v-else />
  </v-modal>
</template>

<style lang="scss"></style>
